import { Badge, BadgeProps } from '@chakra-ui/react'

export const ValidityBadge = ({
  valid,
  ...rest
}: { valid: boolean } & BadgeProps) => {
  return (
    <Badge colorScheme={valid ? 'green' : 'orange'} {...rest}>
      {valid ? 'Aktivní' : 'Neaktivní'}
      {rest.children}
    </Badge>
  )
}
